import React, {PureComponent} from "react"
import styled from "styled-components"

import {Emoji} from "emoji-mart"
import {Para} from "@irati/ui/src/Labels"
import Icon from "@irati/ui/src/Icon"

const Flex = styled.div`
  display: flex;
  align-items: center;
`

const StyledPara = styled(Para)`
  margin-left: 10px;
`

interface Props {
  emoji: string,
  text: string,
  isIcon?: boolean
}

const StyledIcon = styled(Icon)`
  position: relative;
  bottom: 5px;
`

class EmojiWithText extends PureComponent<Props> {
  render() {
    const {emoji, text, isIcon} = this.props
    return (
      <Flex>
        {isIcon ? <StyledIcon icon={emoji} size={14} /> : <Emoji emoji={{id: emoji}} size={14} set="apple" />}
        <StyledPara>{text}</StyledPara>
      </Flex>
    )
  }
}

export default EmojiWithText
